import { TipoAtendimentoProfissional } from 'graphql/types.generated'

export const removerRegistroTitleMessage = (
  tipoAtendimentoProfissional: TipoAtendimentoProfissional,
  nomeCidadao: string
): string => {
  if (tipoAtendimentoProfissional === TipoAtendimentoProfissional.VACINACAO) {
    return `Deseja remover o atendimento de vacinação de ${nomeCidadao}?`
  }
  return `Deseja remover esse registro do prontuário de ${nomeCidadao}?`
}

export const confirmarEdicaoTitleMessage = (
  tipoAtendimentoProfissional: TipoAtendimentoProfissional,
  nomeCidadao: string
): string => {
  if (tipoAtendimentoProfissional === TipoAtendimentoProfissional.VACINACAO) {
    return `Deseja confirmar a edição do registro de vacinação de ${nomeCidadao}?`
  }
  return `Deseja confirmar a edição do registro do prontuário de ${nomeCidadao}?`
}
